import type { FC } from 'react'
import React from 'react'

import type { SvgProps } from './types'
import createComponent from '../../../styles-system/create-component'

const Component = createComponent('svg', 'csg')

const Svg: FC<SvgProps> = React.forwardRef<SVGSVGElement, SvgProps>(
  function Svg(props, ref) {
    const { size, strokeWidth, viewBox, width, height, className } = props
    return (
      <Component
        ref={ref}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        width={size ? size + '' : width}
        height={size ? size + '' : height}
        strokeWidth={strokeWidth}
        stroke={strokeWidth ? 'currentcolor' : 'none'}
        fill={strokeWidth ? 'none' : 'currentcolor'}
        {...props}
      />
    )
  }
)

export default Svg
